module.exports = __webpack_public_path__ + "static/menuIcon-bc23eaea43578cba2b7af9724a346e06.png";